import { AxiosInstance } from "axios";
import { BoardStatusEnum } from "enums/BoardStatusEnum";
import { BoardWithPermissionsModel } from "models/BoardWithPermissionsModel";
import { PaginatedList } from "models/PaginatedList";

export interface BoardsQuery {
  q?: string;
  skip?: number;
  take?: number;
  status?: BoardStatusEnum;
}

export class BoardsApi {
  constructor(private axios: AxiosInstance) {}

  async getBoards(query?: BoardsQuery, signal?: AbortSignal): Promise<PaginatedList<BoardWithPermissionsModel>> {
    const response = await this.axios.get<PaginatedList<BoardWithPermissionsModel>>("api/boards", {
      params: query,
      signal,
    });
    return response.data;
  }
}
